import { render, staticRenderFns } from "./FamilyList.vue?vue&type=template&id=0eceb086&scoped=true&lang=pug"
import script from "./FamilyList.vue?vue&type=script&lang=ts"
export * from "./FamilyList.vue?vue&type=script&lang=ts"
import style0 from "./FamilyList.vue?vue&type=style&index=0&id=0eceb086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eceb086",
  null
  
)

export default component.exports